import { Injectable } from '@angular/core';
import { PortalTraceData, PortalTraceEvent, PortalTraceScreen } from './portal-trace.models';

/**
 * Ne conserve que le domaine d'un e-mail (ex. `a@b.fr` -> `@b.fr`).
 * À utiliser pour toute donnée d'e-mail placée dans une trace : jamais d'e-mail complet.
 */
export function emailDomain(email: string | null | undefined): string {
    const value = email ?? '';
    const index = value.lastIndexOf('@');
    return index >= 0 ? value.substring(index) : '';
}

/**
 * Point UNIQUE de trace des parcours Portal.
 * Aujourd'hui : console structurée. À rebrancher ici (Sentry, endpoint de logs...) sans toucher aux appelants.
 * Interdit : e-mail complet, mot de passe, jeton.
 */
@Injectable({ providedIn: 'root' })
export class PortalTraceService {
    trace(screen: PortalTraceScreen, event: PortalTraceEvent, data?: PortalTraceData): void {
        console.info('[PORTAL_TRACE]', { screen, event, at: new Date().toISOString(), ...data });
    }
}
